const GET_ATTENDANCE_WORK_CLASSIFICATION = 'GET_ATTENDANCE_WORK_CLASSIFICATION'
const GET_ATTENDANCE_WORK_CLASSIFICATION_SUCCESS = 'GET_ATTENDANCE_WORK_CLASSIFICATION_SUCCESS'

const GET_ATTENDANCE_WORK_TODAY = 'GET_ATTENDANCE_WORK_TODAY'
const GET_ATTENDANCE_WORK_TODAY_SUCCESS = 'GET_ATTENDANCE_WORK_TODAY_SUCCESS'

const GET_ATTENDANCE_OTHER_WORK_LIST = 'GET_ATTENDANCE_OTHER_WORK_LIST'
const GET_ATTENDANCE_OTHER_WORK_LIST_SUCCESS = 'GET_ATTENDANCE_OTHER_WORK_LIST_SUCCESS'

const GET_ATTENDANCE_ALL_ORDER_LIST = 'GET_ATTENDANCE_ALL_ORDER_LIST'
const GET_ATTENDANCE_ALL_ORDER_LIST_SUCCESS = 'GET_ATTENDANCE_ALL_ORDER_LIST_SUCCESS'

const GET_ATTENDANCE_HISTORY = 'GET_ATTENDANCE_HISTORY'
const GET_ATTENDANCE_HISTORY_SUCCESS = 'GET_ATTENDANCE_HISTORY_SUCCESS'

// const GET_ATTENDANCE_HISTORY_BY_STAFF = 'GET_ATTENDANCE_HISTORY_BY_STAFF'
// const GET_ATTENDANCE_HISTORY_BY_STAFF_SUCCESS = 'GET_ATTENDANCE_HISTORY_BY_STAFF_SUCCESS'

const GET_ATTENDANCE_HISTORY_BY_DATE = 'GET_ATTENDANCE_HISTORY_BY_DATE'
const GET_ATTENDANCE_HISTORY_BY_DATE_SUCCESS = 'GET_ATTENDANCE_HISTORY_BY_DATE_SUCCESS'

const GET_ATTENDANCE_DETAIL_HISTORY_DATE = 'GET_ATTENDANCE_DETAIL_HISTORY_DATE'
const GET_ATTENDANCE_DETAIL_HISTORY_DATE_SUCCESS = 'GET_ATTENDANCE_DETAIL_HISTORY_DATE_SUCCESS'

const GET_ATTENDANCE_ASSIGMENT_LIST = 'GET_ATTENDANCE_ASSIGMENT_LIST'
const GET_ATTENDANCE_ASSIGMENT_LIST_SUCCESS = 'GET_ATTENDANCE_ASSIGMENT_LIST_SUCCESS'

const POST_CLOCK_IN = 'POST_CLOCK_IN'
const POST_CLOCK_IN_SUCCESS = 'POST_CLOCK_IN_SUCCESS'

const POST_CLOCK_OUT = 'POST_CLOCK_OUT'
const POST_CLOCK_OUT_SUCCESS = 'POST_CLOCK_OUT_SUCCESS'

const PUT_ATTENDANCE_DATE = 'PUT_ATTENDANCE_DATE'
const PUT_ATTENDANCE_DATE_SUCCESS = 'PUT_ATTENDANCE_DATE_SUCCESS'

const DELETE_ATTENDANCE = 'DELETE_ATTENDANCE'
const DELETE_ATTENDANCE_SUCCESS = 'DELETE_ATTENDANCE_SUCCESS'



// const PUT_ATTENDANCE_DATE_STAFF = 'PUT_ATTENDANCE_DATE_STAFF'
// const PUT_ATTENDANCE_DATE_STAFF_SUCCESS = 'PUT_ATTENDANCE_DATE_STAFF_SUCCESS'


const AttendanceType = {
  GET_ATTENDANCE_WORK_CLASSIFICATION,
  GET_ATTENDANCE_WORK_CLASSIFICATION_SUCCESS,

  GET_ATTENDANCE_WORK_TODAY,
  GET_ATTENDANCE_WORK_TODAY_SUCCESS,

  GET_ATTENDANCE_OTHER_WORK_LIST,
  GET_ATTENDANCE_OTHER_WORK_LIST_SUCCESS,

  GET_ATTENDANCE_ALL_ORDER_LIST,
  GET_ATTENDANCE_ALL_ORDER_LIST_SUCCESS,

  GET_ATTENDANCE_HISTORY,
  GET_ATTENDANCE_HISTORY_SUCCESS,

  // GET_ATTENDANCE_HISTORY_BY_STAFF,
  // GET_ATTENDANCE_HISTORY_BY_STAFF_SUCCESS,

  GET_ATTENDANCE_HISTORY_BY_DATE,
  GET_ATTENDANCE_HISTORY_BY_DATE_SUCCESS,

  GET_ATTENDANCE_DETAIL_HISTORY_DATE,
  GET_ATTENDANCE_DETAIL_HISTORY_DATE_SUCCESS,

  GET_ATTENDANCE_ASSIGMENT_LIST,
  GET_ATTENDANCE_ASSIGMENT_LIST_SUCCESS,

  POST_CLOCK_IN,
  POST_CLOCK_IN_SUCCESS,

  POST_CLOCK_OUT,
  POST_CLOCK_OUT_SUCCESS,

  PUT_ATTENDANCE_DATE,
  PUT_ATTENDANCE_DATE_SUCCESS,

  DELETE_ATTENDANCE,
  DELETE_ATTENDANCE_SUCCESS

  // PUT_ATTENDANCE_DATE_STAFF,
  // PUT_ATTENDANCE_DATE_STAFF_SUCCESS

}

export default AttendanceType
